export const loginSelector = {
  submit: "login-button",
};
